import { ctdIdentityRows } from '../ctdIdentity';
import { Placeholder, withInlinePlaceholders } from './DossierPrimitives';

/** The EU CTD's identity — what the PDF cover states, one cell per row; a value not on file is
 *  a "Submitter must complete" chip, as on the PDF. Mirrors CombinedIdentityCard. */
export function CtdIdentityCard({
  applicationForm,
  legalBasisLabel,
  productName,
  productType,
  company,
}: {
  applicationForm: Record<string, unknown> | null | undefined;
  legalBasisLabel?: string | null;
  productName?: string | null;
  productType?: string | null;
  company?: string | null;
}) {
  return (
    <section
      aria-label="Dossier identity"
      className="bg-white border border-line rounded-2xl p-6 shadow-card mt-4"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {ctdIdentityRows(applicationForm, { legalBasisLabel, productName, productType, company }).map((row) => (
          <div key={row.label} className="bg-surface-muted rounded-md py-2.5 px-3">
            <div className="text-[10px] uppercase tracking-[0.12em] font-bold text-muted mb-0.5">
              {row.label}
            </div>
            <div className="text-[13px] text-navy">
              {/* A stated value may carry a placeholder for a missing detail — shown as a chip. */}
              {row.value ? withInlinePlaceholders(row.value) : <Placeholder hint={row.hint} />}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
